import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import SeoHead from "@/components/SeoHead";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Section from "@/components/Section";
import Reveal from "@/components/Reveal";
import NewsletterSignup from "@/components/NewsletterSignup";
import { useLanguage } from "@/i18n/useLanguage";

const Newsletter = () => {
  const { t } = useTranslation();
  const { localize } = useLanguage();

  return (
    <>
      <SeoHead
        title={{
          en: "Newsletter | AI-labbet",
          sv: "Nyhetsbrev | AI-labbet",
        }}
        description={{
          en: "Subscribe to the AI-labbet newsletter — a short monthly email with articles, events, and resources.",
          sv: "Prenumerera på AI-labbets nyhetsbrev – ett kort månadsbrev med artiklar, event och resurser.",
        }}
        path="/newsletter"
      />

      <div className="min-h-screen bg-background flex flex-col">
        <Header />
        <main className="flex-1">
          <Section
            title={t("newsletter.page.title")}
            titleAs="h1"
            align="center"
          >
            <Reveal>
              <NewsletterSignup variant="hero" source="newsletter_page" />
              <p className="text-xs text-muted-foreground text-center mt-4">
                {t("newsletter.page.disclaimer")}
              </p>
              <div className="mt-8 text-center">
                <Link
                  to={localize("/news")}
                  className="inline-flex items-center gap-2 text-primary hover:text-primary/80 font-medium"
                >
                  {t("newsletter.page.archiveCta")}
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </Reveal>
          </Section>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Newsletter;
